import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setDrawerVisible, toggleDrawerVisible, setCurrentDrawerWidth } from './redux/slices/drawerSlice';

export const DrawerProvider = ({ children }) => {
  return <>{children}</>;
};

export const useDrawer = () => {
  const dispatch = useDispatch();
  const { drawerVisible, currentDrawerWidth } = useSelector((state) => state.drawer || { drawerVisible: true, currentDrawerWidth: 240 });

  return {
    drawerVisible,
    currentDrawerWidth,
    setDrawerVisible: (val) => dispatch(setDrawerVisible(val)),
    toggleDrawerVisible: () => dispatch(toggleDrawerVisible()),
    setCurrentDrawerWidth: (val) => dispatch(setCurrentDrawerWidth(val)),
  };
};

export default useDrawer;